import { Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { ColumnComponentProps } from '../../../types/activity-column-types';

export function IsUpdatedColumn({
  info,
}: ColumnComponentProps<BackofficeActivitiesOrderItem, boolean | undefined>) {
  if (info.getValue() === true) {
    return (
      <Text fontSize="sm" fontWeight="400" color="#373F41">
        Diubah{' '}
        {info.row.original.update_origin === 'admin'
          ? 'oleh Admin'
          : 'oleh SAP'}
      </Text>
    );
  }

  return (
    <Text fontSize="sm" fontWeight="400" color="#373F41">
      -
    </Text>
  );
}
